import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card, Button } from 'react-bootstrap';
import UttamKalakarFooter from './UttamKalakarFooter';
import { jsPDF } from 'jspdf';

const MyCertificateReview = () => {
    const [titlesList, setTitlesList] = useState([]);
    const [selectedArticle, setSelectedArticle] = useState(null);

    useEffect(() => {
        const fetchTitles = async () => {
            try {
                const response = await axios.get(
                    `https://nrdruhs.in/api/getPublishedManuscriptsWithReviewer`
                );

                setTitlesList(response.data.titles || []);
            } catch (error) {
                console.error('Error fetching titles:', error.message);
            }
        };

        fetchTitles();
    }, []);

    

    // ✅ Generate PDF
    const handleGeneratePDFCertificate = () => {
        if (!selectedArticle) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select a title',
            });
            return;
        }

        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'a4'
        });

        const image = new Image();
        image.src = '/assets/CertificateNRDRUHSBG.jpg';

        image.onload = () => {
            const pageWidth = doc.internal.pageSize.width;

            // ✅ Left margin shift
            const leftMargin = 215;
            const centerX = (pageWidth + leftMargin) / 2;

            // Background Image
            doc.addImage(
                image,
                'JPEG',
                0,
                0,
                pageWidth,
                doc.internal.pageSize.height
            );

            // Title
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(18);
            doc.setTextColor(204, 102, 0);

            doc.text(
                selectedArticle.title.toUpperCase(),
                centerX,
                400,
                { align: 'center' }
            );

            // Reviewer Name
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(15);
            doc.setTextColor(0, 0, 0);

            doc.text(
                `${selectedArticle.reviewby || 'N/A'}`,
                centerX,
                290,
                { align: 'center' }
            );

            // ✅ Designation (NEW)
            doc.text(
                selectedArticle.designation || '',
                centerX,
                310,
                { align: 'center' }
            );

            // Institute Name (NEW)
            doc.text(
                `${selectedArticle.institutename || ''}`,
                centerX,
                330,
                { align: 'center' }
            );


            doc.save('Certificate.pdf');
        };
    };

    return (
        <div>
            <div className="main-content">
                <img
                    src="/assets/NRDRUHSHomeBanner.jpg"
                    alt="Background"
                    className="header-image"
                    style={{ width: '100%', height: '60vh', objectFit: 'cover' }}
                />
            </div>

            <div style={{ marginTop: 100, marginBottom: 100 }}>
                <Card
                    style={{
                        margin: '0 auto',
                        maxWidth: 600,
                        background: 'linear-gradient(to right, #5433ff, #20bdff, #a5fecb)'
                    }}
                >
                    <Card.Body>
                        <h3 style={{ textAlign: 'center', padding: 15, fontWeight: 'bold' }}>
                            Generate Certificate
                        </h3>

                        <select
                            className="form-select form-select-lg"
                            value={selectedArticle?.articleid || ''}
                            onChange={(e) => {
                                const selected = titlesList.find(
                                    t => t.articleid == e.target.value
                                );
                                setSelectedArticle(selected);
                            }}
                        >
                            <option value="">Select a title</option>

                            {titlesList.map((t) => (
                                <option key={t.articleid} value={t.articleid}>
                                    {t.title} - {t.articleid}
                                </option>
                            ))}
                        </select>

                    </Card.Body>
                </Card>

                {/* ✅ Buttons with proper spacing */}
                <div
                    className="text-center"
                    style={{ marginTop: 100 }}
                >
                    

                    <Button
                        variant="success"
                        onClick={handleGeneratePDFCertificate}
                    >
                        Generate PDF Certificate
                    </Button>
                </div>
            </div>

            <UttamKalakarFooter />

            <div className="row" style={{ height: 60, margin: 0, background: 'black' }}>
                <p
                    className="copyright"
                    style={{
                        fontSize: 15,
                        color: '#999',
                        textAlign: 'center',
                        paddingTop: 18
                    }}
                >
                    Copyrights © NRD RUHS Jaipur
                </p>
            </div>
        </div>
    );
};

export default MyCertificateReview;
